'use es6';

export const FORECAST_MEASUREMENTS = {
  BAR_HEIGHT: '75px',
  STAGE_AMOUNT_HEIGHT: '36px',
  STAGE_LABEL_HEIGHT: '24px',
  FLAG_LABEL_HEIGHT: '30px'
};